import {
	LOGIN_REQUEST,
	LOGIN_FAIL,
	LOGIN_SUCCESS,
	CREATE_JOB_REQUEST,
	CREATE_JOB_SUCCESS,
	CREATE_JOB_FAIL,
	REGISTER_USER_REQUEST,
	REGISTER_USER_SUCCESS,
	REGISTER_USER_FAIL,
	LOAD_USER_REQUEST,
	LOAD_USER_SUCCESS,
	LOAD_USER_FAIL,
	LOGOUT_SUCCESS,
	LOGOUT_FAIL,
	UPDATE_PROFILE_REQUEST,
	UPDATE_PROFILE_SUCCESS,
	UPDATE_PROFILE_FAIL,
	UPDATE_JOBSTATUS_REQUEST,
	UPDATE_JOBSTATUS_SUCCESS,
	UPDATE_JOBSTATUS_FAIL,
	UPDATE_PASSWORD_REQUEST,
	UPDATE_PASSWORD_SUCCESS,
	UPDATE_PASSWORD_FAIL,
	FORGOT_PASSWORD_REQUEST,
	FORGOT_PASSWORD_SUCCESS,
	FORGOT_PASSWORD_FAIL,
	RESET_PASSWORD_REQUEST,
	RESET_PASSWORD_SUCCESS,
	RESET_PASSWORD_FAIL,
	ALL_USERS_REQUEST,
	ALL_USERS_SUCCESS,
	ALL_USERS_FAIL,
	DELETE_USER_REQUEST,
	DELETE_USER_SUCCESS,
	DELETE_USER_FAIL,
	DELETE_JOB_REQUEST,
	DELETE_JOB_SUCCESS,
	DELETE_JOB_FAIL,
	UPDATE_USER_REQUEST,
	UPDATE_USER_SUCCESS,
	UPDATE_USER_FAIL,
	CV_UPLOADED_REQUEST,
	CV_UPLOADED_SUCCESS,
	CV_UPLOADED_FAIL,
	JOBS_DETAILS_REQUEST,
	JOBS_DETAILS_SUCCESS,
	JOBS_DETAILS_FAIL,
	SINGLE_JOB_DETAILS_REQUEST,
	SINGLE_JOB_DETAILS_SUCCESS,
	SINGLE_JOB_DETAILS_FAIL,
	ADD_CANDIDATE_REQUEST,
	ADD_CANDIDATE_SUCCESS,
	ADD_CANDIDATE_FAIL,
	GET_ALL_CANDIDATES_OF_JOB_REQUEST,
	GET_ALL_CANDIDATES_OF_JOB_SUCCESS,
	GET_ALL_CANDIDATES_OF_JOB_FAIL,
	GET_ALL_CUSTOMER_OF_CORP_REQUEST,
	GET_ALL_CUSTOMER_OF_CORP_SUCCESS,
	GET_ALL_CUSTOMER_OF_CORP_FAIL,
	CLEAR_ERRORS,
	TOGGLE_IS_ON,
	SET_LOGO,
	NOTIFICATIONS_REQUEST,
	NOTIFICATIONS_SUCCESS,
	NOTIFICATIONS_FAIL,
	TEAM_MEMBERS_REQUEST,
	TEAM_MEMBERS_SUCCESS,
	TEAM_MEMBERS_FAIL
} from "../constants/userConstants";
import axios from "axios";
import cookieCutter from "cookie-cutter";
import { getCorporateToken, setCorporateToken, clearCorporateToken, getCandidateToken } from "../utils/authTokens";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import mixpanel from "mixpanel-browser";

// export const login = (email, password) => async (dispatch) => {
//   try {
//     dispatch({ type: LOGIN_REQUEST });

//     // Clear previous cookies and local storage
//     cookieCutter.set("token", "");
//     localStorage.clear();

//     const config = { headers: { "Content-Type": "application/json" } };

//     const { data } = await axios.post(
//       `/api/v1/corporateLogin`,
//       { email, password },
//       config
//     );

//     // Log full response for debugging
//     console.log("Login Full Response:", data);
//     console.log("User Profile Status:", data.user.profileFilled);

//     // Dispatch login success
//     dispatch({ type: LOGIN_SUCCESS, payload: data.user });
//     cookieCutter.set("token", data.token);

//     // Direct redirect to dashboard
//     console.log("Redirecting to Corporate Dashboard");
//     window.location.href = "/corporate/dashboard";

//   } catch (error) {
//     dispatch({
//       type: LOGIN_FAIL,
//       payload: error?.response?.data?.message
//     });
//   }
// };

//admin login

export const login = (email, password) => async (dispatch) => {
	try {
		dispatch({ type: LOGIN_REQUEST });

		const config = { headers: { "Content-Type": "application/json" } };

		const { data } = await axios.post(
			`/api/v1/corporateLogin`,
			{ email, password },
			config,
		);

		// Debugging logs



		// Save token only if login is successful
		setCorporateToken(data.token);

		// Dispatch login success
		dispatch({ type: LOGIN_SUCCESS, payload: data.user });

		// Return success response for further handling
		return { status: 200, data };
	} catch (error) {
		const errorMessage =
			error?.response?.data?.message || "Login failed. Please try again.";

		dispatch({
			type: LOGIN_FAIL,
			payload: errorMessage,
		});

		// Return failure response
		return { status: error?.response?.status || 500, message: errorMessage };
	}
};

export const loginAdmin = (email, password) => async (dispatch) => {
	try {
		dispatch({ type: LOGIN_REQUEST });

		// Clear previous cookies and local storage
		clearCorporateToken(); // Clear the existing token cookie
		localStorage.clear(); // Clear local storage

		const config = { headers: { "Content-Type": "application/json" } };

		const { data } = await axios.post(
			`/api/v1/corporateLogin`,
			{ email, password },
			config,
		);
		dispatch({ type: LOGIN_SUCCESS, payload: data.user });
		setCorporateToken(data.token);
		window.location.href = "/admin/dashboard";
	} catch (error) {
		//  / dispatch({type:LOGIN_RESET});
		dispatch({ type: LOGIN_FAIL, payload: error?.response?.data?.message });
	}
};

// Register
export const register = (userData) => async (dispatch) => {
	try {
		dispatch({ type: REGISTER_USER_REQUEST });

		const config = { headers: { "Content-Type": "multipart/form-data" } };

		const { data } = await axios.post(
			`/api/v1/registerCorporateUser`,
			userData,
			config,
		);

		dispatch({ type: REGISTER_USER_SUCCESS, payload: data.user });
	} catch (error) {
		dispatch({
			type: REGISTER_USER_FAIL,
			payload: error.response.data.message,
		});
	}
};

// PERF: Prevent concurrent/rapid loadUser calls. Without this guard,
// multiple components calling loadUser() simultaneously would each trigger
// LOAD_USER_REQUEST → new state → re-render → potential cascading calls.
let _loadUserPromise = null;
let _loadUserLastCall = 0;
const LOAD_USER_DEBOUNCE_MS = 2000;

export const loadUser = () => async (dispatch) => {
	try {
		const token = getCorporateToken();
		
		// If no token, fail immediately
		if (!token) {
			dispatch({ type: LOAD_USER_FAIL, payload: "No authentication token" });
			return null;
		}
		
		// Deduplicate: if a loadUser call is already in-flight, return its promise
		if (_loadUserPromise) {
			return _loadUserPromise;
		}
		
		// Debounce: if we called within the last 2 seconds, skip
		const now = Date.now();
		if (now - _loadUserLastCall < LOAD_USER_DEBOUNCE_MS) {
			return null;
		}
		_loadUserLastCall = now;
		
		const config = token;
		dispatch({ type: LOAD_USER_REQUEST });
		_loadUserPromise = axios(`/api/v1/corporateUser`, {
			method: "GET",
			headers: { "Content-Type": "application/json", token, methods: "GET" },
			credentials: "include",
		});
		const response = await _loadUserPromise;
		_loadUserPromise = null;
		if (response) {
			if (response?.data?.user) {
				mixpanel.identify(response?.data?.user?._id);
			}
			dispatch({ type: LOAD_USER_SUCCESS, payload: response.data.user });
			return response.data.user
		} else {
			dispatch({ type: LOAD_USER_FAIL, payload: "Failed to load user" });
			return null;
		}
	} catch (error) {
		_loadUserPromise = null;
		dispatch({ type: LOAD_USER_FAIL, payload: error?.response?.data?.message });
		
		// Return null to indicate failure - caller can handle redirect
		return null;
	}
};
// Logout User
export const logout = () => async (dispatch) => {
	try {
		await axios.get(`/api/v1/logout`);

		dispatch({ type: LOGOUT_SUCCESS });
	} catch (error) {
		dispatch({ type: LOGOUT_FAIL, payload: error.response.data.message });
	}
};

// Update Profile
export const updateProfile = (user) => async (dispatch) => {
	const formData = new FormData();
	formData.append("logo", user.get("logo"));
	formData.append("companyLegalName", user.get("companyLegalName"));
	formData.append("email", user.get("email"));
	formData.append("mobile", user.get("mobile"));
	formData.append("designation", user.get("designation"));
	formData.append("password", user.get("password"));
	formData.append("companyName", user.get("companyName"));
	formData.append("userName", user.get("userName"));
	formData.append("companyWebsite", user.get("companyWebsite"));
	formData.append("companyDescription", user.get("companyDescription"));
	formData.append("industryType", user.get("industryType"));
	formData.append("companyType", user.get("companyType"));
	formData.append("companyStage", user.get("companyStage"));
	formData.append("subscriptionPlan", user.get("subscriptionPlan"));
	formData.append("packageName", user.get("packageName"));
	formData.append("companyLinkedin", user.get("companyLinkedin"));
	formData.append("agency", user.get("agency"));
	formData.append("company", user.get("company"));
	formData.append("college", user.get("college"));
	formData.append("country", user.get("country"));
	formData.append("orgType", user.get("orgType"));
	// const mobile = user.get("mobile");
	// const designation = user.get("designation");
	// const password = user.get("password");
	// const companyName = user.get("companyName");
	// const companyLegalName = user.get("companyLegalName");
	// const logo = null;
	// const companyWebsite = user.get("companyWebsite");
	// const companyDescription = user.get("companyDescription");
	// const industryType = "Ad Sales";
	// const companyType = "Product Based";
	// const companyStage = "SWE";
	// const subscriptionPlan = user.get("subscriptionPlan");
	// const packageName = user.get("packageName");
	// const companyLinkedin = user.get("companyLinkedin");

	// const userData = {
	//   userName,
	//   email,
	//   mobile,
	//   designation,
	//   password,
	//   companyName,
	//   companyLegalName,
	//   logo,
	//   companyWebsite,
	//   companyDescription,
	//   industryType,
	//   companyType,
	//   companyStage,
	//   subscriptionPlan,
	//   packageName,
	//   companyLinkedin,
	// };
	try {
		dispatch({ type: UPDATE_PROFILE_REQUEST });
		const token = getCorporateToken();

		// const config = { headers: { "Content-Type": "application/json" }, token };
		const config = token;
		// const { data } = await axios.post(`/api/v1/corporateUpdateProfile/update`,
		//   formData,
		//   config,
		//   // withCredentials: true,
		//   // userData,
		// );
		formData.append("config", config);
		const { data } = await axios.post(
			`/api/v1/corporateUpdateProfile/update`,
			formData,
			config,
		);
		dispatch({ type: UPDATE_PROFILE_SUCCESS, payload: data?.success });
		return data;
		dispatch(loadUser());
	} catch (error) {
		dispatch({
			type: UPDATE_PROFILE_FAIL,
			payload: error?.response?.data?.message,
		});
	}
};

// Update Profile
export const updateJobStatus = (userData) => async (dispatch) => {
	try {
		dispatch({ type: UPDATE_JOBSTATUS_REQUEST });
		const token = getCorporateToken();
		const config = { headers: { "Content-Type": "application/json" }, token };
		const { data } = await axios.put(`/api/v1/updateJobStatus`, {
			config,
			withCredentials: true,
			userData,
		});
		dispatch({ type: UPDATE_JOBSTATUS_SUCCESS, payload: data?.success });
	} catch (error) {
		// console.log(error);
		dispatch({
			type: UPDATE_JOBSTATUS_FAIL,
			payload: error?.response?.data?.message,
		});
	}
};

// Delete Job
export const deleteJob = (id) => async (dispatch) => {
	try {
		const token = getCorporateToken();
		dispatch({ type: DELETE_JOB_REQUEST });
		const { data } = await axios.delete(`/api/v1/deleteJob/${id}`, {
			data: { config: token }
		});
		dispatch({ type: DELETE_JOB_SUCCESS, payload: data?.success });
	} catch (error) {
		dispatch({
			type: DELETE_JOB_FAIL,
			payload: error?.response?.data?.message,
		});
	}
};

// Delete Customer
export const deleteCustomer = (id) => async (dispatch) => {
	try {
		const token = getCorporateToken();
		const { data } = await axios.delete(`/api/v1/deleteCustomer/${id}`, {
			data: { config: token }
		});
		return data;
	} catch (error) {
		throw error;
	}
};

// Update Customer
export const updateCustomer = (id, customerData) => async (dispatch) => {
	try {
		const token = getCorporateToken();
		// Include token in body as config (same pattern as other authenticated requests)
		const { data } = await axios.put(`/api/v1/updateCustomer/${encodeURIComponent(id)}`, {
			...customerData,
			config: token
		}, {
			headers: { 
				"Content-Type": "application/json",
				"token": token
			}
		});
		return data;
	} catch (error) {
		throw error;
	}
};

// Generate AI fields for a job (skills, experience, jobFunction, etc.)
export const generateJobAIFields = (jobId) => async (dispatch) => {
	try {
		const token = getCorporateToken();
		const { data } = await axios.post(`/api/v1/generateAIFields/${jobId}`, {
			config: token
		}, {
			headers: { 
				"Content-Type": "application/json",
				"token": token
			}
		});
		return data;
	} catch (error) {
		throw error;
	}
};

// Update job skills
export const updateJobSkills = (jobId, skills, primarySkill) => async (dispatch) => {
	try {
		const token = getCorporateToken();
		const { data } = await axios.put(`/api/v1/updateJobSkills/${jobId}`, {
			skills,
			primarySkill
		}, {
			headers: { 
				"Content-Type": "application/json",
				"token": token
			}
		});
		return data;
	} catch (error) {
		throw error;
	}
};

//Create Job
export const createJob = (user) => async (dispatch) => {
	const formData = new FormData();
	formData.append("jobTitle", user.get("jobTitle") || "");
	formData.append("uploadJd", user.get("uploadJd") || "");
	const skills = user.get("skills");
	formData.append("skills", Array.isArray(skills) ? skills.join(",") : (skills || ""));
	formData.append("jdText", user.get("jd")?.jdText || "");
	formData.append("createJd", user.get("createJd") || "");
	if (
		user.get("codingRound") === "select options" ||
		!(
			user.get("jobFunction") === "Engineering" ||
			user.get("jobFunction") === "Product Management"
		)
	) {
		formData.append("codingRound", 0);
	} else {
		formData.append("codingRound", user.get("codingRound") || "");
		formData.append("codingRoundDuration", user.get("codingRoundDuration") || "")
	}
	formData.append("experienceRequired", user.get("experienceRequired") || "");
	formData.append("jobType", user.get("jobType") || "");
	formData.append("customerId", user.get("customerId") || "");
	formData.append("location", user.get("location") || "");
	formData.append("jobFunction", user.get("jobFunction") || "");
	formData.append("primarySkill", user.get("primarySkill") || "");
	formData.append("vernacular", user.get("vernacular") || "");
	formData.append(
		"minimumExperienceReqForPrimarySkill",
		user.get("minimumExperienceReqForPrimarySkill") || "",
	);
	try {
		dispatch({ type: CREATE_JOB_REQUEST });
		const token = getCorporateToken();
		const config = token;
		formData.append("config", config);
		// const { data } = await axios.post(`/api/v1/createAJob`, formData, config);
		const axiosConfig = {
			headers: {
				"Content-Type": "multipart/form-data",
				Authorization: `Bearer ${token}`,
			},
			timeout: 1200000, // wait up to 60 seconds
		};
		
		const { data } = await axios.post(`/api/v1/createAJob`, formData, axiosConfig);
		
		dispatch({ type: CREATE_JOB_SUCCESS, payload: data?.success });
		return data;
	} catch (error) {
		console.error("ERror creating job", error);
		toast.error(`Unexpected Error Occured: ${error}`);
		dispatch({
			type: CREATE_JOB_FAIL,
			payload: error?.response?.data?.message,
		});
	}
};

export const addCandidate = (user, id) => async (dispatch) => {
	try {
		dispatch({ type: ADD_CANDIDATE_REQUEST });
		const cv = user.get("cv");
		const name = user.get("name");
		const formData = new FormData();
		formData.append("name", name);
		formData.append("mobile", user.get("mobile"));
		formData.append("email", user.get("email"));
		formData.append("cv", cv);


		const token = getCorporateToken();
		const config = token;

		formData.append("config", config);
		formData.append("params", id);
		formData.append("domain", window.location.hostname)

		const response = await axios.post(
			`/api/v1/addCandidate`,
			formData,
			config, // Pass the formData object here
			// Pass the config object here
		);

		// console.log("res", response);
		// console.log("response", response.data);

		const data = await response.json();

		// console.log(data);
		if (data.ok) {
			// Success case, candidate added successfully
			dispatch({ type: ADD_CANDIDATE_SUCCESS, payload: data?.success }); // Dispatch a success action
			return { success: true, data }; // Return success flag and response data
		} else {
			// Error case, candidate not added
			// console.log("error");
			dispatch({ type: ADD_CANDIDATE_FAIL, payload: data }); // Dispatch a failure action
			return { success: false, message: data.message }; // Return failure flag and error message
		}
	} catch (error) {
		// console.log(error);
		dispatch({
			type: ADD_CANDIDATE_FAIL,
			payload: error?.response?.data?.message,
		});
	}
};

// Update Password
export const updatePassword = (passwords) => async (dispatch) => {
	const oldPassword = passwords.get("oldPassword");
	const newPassword = passwords.get("newPassword");
	const confirmPassword = passwords.get("confirmPassword");
	const passwordData = {
		oldPassword,
		newPassword,
		confirmPassword,
	};
	try {
		dispatch({ type: UPDATE_PASSWORD_REQUEST });

		const token = getCorporateToken();
		const config = { headers: { "Content-Type": "application/json" }, token };
		const { data } = await axios.put(`/api/v1/corporateUpdatePassword/update`, {
			config,
			withCredentials: true,
			passwordData,
		});

		dispatch({ type: UPDATE_PASSWORD_SUCCESS, payload: data.success });
	} catch (error) {
		dispatch({
			type: UPDATE_PASSWORD_FAIL,
			payload: error.response.data.message,
		});
	}
};

// Update Password (for candidates)
export const candidateUpdatePassword = (passwords) => async (dispatch) => {
	// console.log("here");
	const oldPassword = passwords.get("oldPassword");
	const newPassword = passwords.get("newPassword");
	const confirmPassword = passwords.get("confirmPassword");
	const passwordData = {
		oldPassword,
		newPassword,
		confirmPassword,
	};
	try {
		dispatch({ type: UPDATE_PASSWORD_REQUEST });

		const token = getCandidateToken();
		const config = { headers: { "Content-Type": "application/json" }, token };
		const { data } = await axios.put(`/api/v1/candidateUpdatePassword/update`, {
			config,
			withCredentials: true,
			passwordData,
		});

		dispatch({ type: UPDATE_PASSWORD_SUCCESS, payload: data.success });
	} catch (error) {
		dispatch({
			type: UPDATE_PASSWORD_FAIL,
			payload: error.response.data.message,
		});
	}
};

export const forgotPassword = (email) => async (dispatch) => {
	try {
		dispatch({ type: FORGOT_PASSWORD_REQUEST });
		const token = getCorporateToken();
		const config = { headers: { "Content-Type": "application/json" }, token };

		const { data } = await axios.post(`/api/v1/password/forgot`, email, config);

		dispatch({ type: FORGOT_PASSWORD_SUCCESS, payload: data.message });
	} catch (error) {
		dispatch({
			type: FORGOT_PASSWORD_FAIL,
			payload: error.response.data.message,
		});
	}
};

// Reset Password
export const resetPassword = (token, passwords) => async (dispatch) => {
	try {
		dispatch({ type: RESET_PASSWORD_REQUEST });
		const token = getCorporateToken();
		const config = { headers: { "Content-Type": "application/json" }, token };

		const { data } = await axios.put(
			`/api/v1/password/reset/${token}`,
			passwords,
			config,
		);

		dispatch({ type: RESET_PASSWORD_SUCCESS, payload: data.success });
	} catch (error) {
		dispatch({
			type: RESET_PASSWORD_FAIL,
			payload: error.response.data.message,
		});
	}
};

// get All Users
export const getAllUsers = () => async (dispatch) => {
	try {
		dispatch({ type: ALL_USERS_REQUEST });
		const token = getCorporateToken();
		const config = { headers: { "Content-Type": "application/json" }, token };
		const { data } = await axios.get(`/api/v1/getNumberOfJobs`);

		dispatch({ type: ALL_USERS_SUCCESS, payload: data.users });
	} catch (error) {
		dispatch({ type: ALL_USERS_FAIL, payload: error.response.data.message });
	}
};

// get  cvsUploaded
export const cvsUploaded = () => async (dispatch) => {
	try {
		const token = getCorporateToken();
		dispatch({ type: CV_UPLOADED_REQUEST });

		const response = await axios(`/api/v1/getNumberOfCVs`, {
			method: "GET",
			headers: { "Content-Type": "application/json", token, methods: "GET" },
			credentials: "include",
		});
		if (response) {
			dispatch({
				type: CV_UPLOADED_SUCCESS,
				payload: response.data.getNumberOfCvs,
			});
		} else {
			dispatch({ type: LOAD_USER_FAIL, payload: "Failed to load user" });
		}
	} catch (error) {
		dispatch({ type: CV_UPLOADED_FAIL, payload: error.response.data.message });
	}
};
//Get All Jobs details
export const getAllCandidatesOfJob = (id) => async (dispatch) => {
	// console.log(id);
	try {
		const token = getCorporateToken();

		dispatch({ type: GET_ALL_CANDIDATES_OF_JOB_REQUEST });

		const response = await axios(`/api/v1/getAllCandidatesOfJob`, {
			method: "GET",
			headers: { "Content-Type": "application/json", token, methods: "GET" },
			credentials: "include",
			params: { id },
		});


		if (response) {
			dispatch({
				type: GET_ALL_CANDIDATES_OF_JOB_SUCCESS,
				payload: { candidatemapping: response.data.candidatesWithMapping },
			});
		} else {
			dispatch({
				type: GET_ALL_CANDIDATES_OF_JOB_FAIL,
				payload: "Failed to get candiates",
			});
		}
	} catch (error) {
		// console.log(error);
		dispatch({
			type: GET_ALL_CANDIDATES_OF_JOB_FAIL,
			payload: error?.message,
		});
	}
};
export const getAllCustomerOfCorp = (id, page = 1, limit = 100, searchName = "", industryType = [], skipStats = false) => async (dispatch) => {
	try {
		const token = getCorporateToken();
		dispatch({ type: GET_ALL_CUSTOMER_OF_CORP_REQUEST });

		// Convert arrays to comma-separated strings for the API
		const industryTypeParam = Array.isArray(industryType) ? industryType.join(',') : industryType;

		const response = await axios(`/api/v1/getAllCustomerOfCorp`, {
			method: "GET",
			headers: { "Content-Type": "application/json", token, methods: "GET" },
			credentials: "include",
			params: { id, page, limit, searchName, industryType: industryTypeParam, skipStats: skipStats ? 'true' : 'false' },
		});
		if (response) {
			dispatch({
				type: GET_ALL_CUSTOMER_OF_CORP_SUCCESS,
				payload: {
					customers: response.data.customers,
					totalCustomers: response.data.totalCount,
					statsLoaded: response.data.statsLoaded
				}
			});
		} else {
			dispatch({
				type: GET_ALL_CUSTOMER_OF_CORP_FAIL,
				payload: "Failed to get customers",
			});
		}
	} catch (error) {
		// console.log("errrrrrrrrrrrrr", error);
		dispatch({
			type: GET_ALL_CUSTOMER_OF_CORP_FAIL,
			payload: error?.message,
		});
	}
};

// Fetch customer stats separately (for background loading)
export const getCustomerStats = async (id) => {
	try {
		const token = getCorporateToken();
		const response = await axios(`/api/v1/customerStats`, {
			method: "GET",
			headers: { "Content-Type": "application/json", token, methods: "GET" },
			credentials: "include",
			params: { id },
		});
		return response.data;
	} catch (error) {
		console.error("Error fetching customer stats:", error);
		return { success: false, stats: {} };
	}
};

// FAST jobs list for infinite scroll - optimized for 120k+ jobs
// This uses a lightweight endpoint that skips expensive aggregations
export const getJobsListFast = (page = 1, limit = 12, filters = {}) => async (dispatch) => {
	try {
		const token = getCorporateToken();
		dispatch({ type: JOBS_DETAILS_REQUEST });

		const params = { page, limit };
		
		if (filters.search) params.search = filters.search;
		if (filters.status) params.status = filters.status;
		if (filters.minExperience !== undefined) params.minExperience = filters.minExperience;
		if (filters.maxExperience !== undefined) params.maxExperience = filters.maxExperience;
		if (filters.skills?.length > 0) params.skills = JSON.stringify(filters.skills);
		if (filters.customers?.length > 0) params.customers = JSON.stringify(filters.customers);
		if (filters.industries?.length > 0) params.industries = JSON.stringify(filters.industries);
		if (filters.teamMembers?.length > 0) params.teamMembers = JSON.stringify(filters.teamMembers);
		if (filters.sortField) params.sortField = filters.sortField;
		if (filters.sortDirection) params.sortDirection = filters.sortDirection;

		const response = await axios(`/api/v1/getJobsListFast`, {
			method: "GET",
			headers: { "Content-Type": "application/json", token, methods: "GET" },
			credentials: "include",
			params
		});
		
		if (response) {
			dispatch({
				type: JOBS_DETAILS_SUCCESS,
				payload: response.data,
			});
			return response.data;
		} else {
			dispatch({
				type: JOBS_DETAILS_FAIL,
				payload: "Failed to get job details",
			});
			return null;
		}
	} catch (error) {
		dispatch({
			type: JOBS_DETAILS_FAIL,
			payload: error?.response?.data?.message,
		});
		return null;
	}
};

// PERF: Prevent concurrent/rapid getALLJobDetails calls (2.1MB per response).
let _getAllJobsPromise = null;
let _getAllJobsLastCall = 0;
let _getAllJobsLastKey = '';
const GET_ALL_JOBS_DEBOUNCE_MS = 3000;

// get all candidates of a job (FULL version with stats - for dashboard)
export const getALLJobDetails = (page = 1, limit = 9, filters = {}) => async (dispatch) => {
	try {
		const token = getCorporateToken();
		const config = token;
		
		// Build a cache key from params to deduplicate identical calls
		const cacheKey = `${page}_${limit}_${JSON.stringify(filters)}`;
		
		// Deduplicate: if same request is already in-flight, return its promise
		if (_getAllJobsPromise && cacheKey === _getAllJobsLastKey) {
			return _getAllJobsPromise;
		}
		
		// Debounce: if same params called within last 3 seconds, skip
		const now = Date.now();
		if (cacheKey === _getAllJobsLastKey && now - _getAllJobsLastCall < GET_ALL_JOBS_DEBOUNCE_MS) {
			return null;
		}
		_getAllJobsLastCall = now;
		_getAllJobsLastKey = cacheKey;
		
		dispatch({ type: JOBS_DETAILS_REQUEST });

		// Build query params including filters
		const params = { page, limit };
		
		// Add filter params if provided
		if (filters.search) params.search = filters.search;
		if (filters.status) params.status = filters.status;
		if (filters.minExperience !== undefined) params.minExperience = filters.minExperience;
		if (filters.maxExperience !== undefined) params.maxExperience = filters.maxExperience;
		if (filters.skills?.length > 0) params.skills = JSON.stringify(filters.skills);
		if (filters.customers?.length > 0) params.customers = JSON.stringify(filters.customers);
		if (filters.industries?.length > 0) params.industries = JSON.stringify(filters.industries);
		if (filters.teamMembers?.length > 0) params.teamMembers = JSON.stringify(filters.teamMembers);
		// Add sorting params
		if (filters.sortField) params.sortField = filters.sortField;
		if (filters.sortDirection) params.sortDirection = filters.sortDirection;
		// Add skipStats to skip expensive candidate stats aggregations (used by jobs page, not dashboard)
		if (filters.skipStats) params.skipStats = 'true';

		_getAllJobsPromise = axios(`/api/v1/getAllJobsDetails`, {
			method: "GET",
			headers: { "Content-Type": "application/json", token, methods: "GET" },
			credentials: "include",
			params
		});
		const response = await _getAllJobsPromise;
		_getAllJobsPromise = null;
		if (response) {
			dispatch({
				type: JOBS_DETAILS_SUCCESS,
				payload: response.data,
			});
			return response.data
		} else {
			dispatch({
				type: JOBS_DETAILS_FAIL,
				payload: "Failed to get job details",
			});
		}
	} catch (error) {
		_getAllJobsPromise = null;
		dispatch({
			type: JOBS_DETAILS_FAIL,
			payload: error?.response?.data?.message,
		});
	}
};

// get single job details
export const getSingleJobDetails = (id) => async (dispatch) => {
	try {
		const token = getCorporateToken();
		dispatch({ type: SINGLE_JOB_DETAILS_REQUEST });

		const response = await axios(`/api/v1/getSingleJobDetails/${id}`, {
			method: "GET",
			headers: { "Content-Type": "application/json", token, methods: "GET" },
			credentials: "include",
		});
		if (response) {
			dispatch({
				type: SINGLE_JOB_DETAILS_SUCCESS,
				payload: response.data.job,
			});
			return response.data.job;
		} else {
			dispatch({
				type: SINGLE_JOB_DETAILS_FAIL,
				payload: "Failed to get job details",
			});
			return null;
		}
	} catch (error) {
		dispatch({
			type: SINGLE_JOB_DETAILS_FAIL,
			payload: error?.response?.data?.message,
		});
		return null;
	}
};
// get all candidates of a job
export const getALLJobDetailsOfCustomer = (id) => async (dispatch) => {
	try {
		const token = getCorporateToken();
		const config = token;
		dispatch({ type: JOBS_DETAILS_REQUEST });

		const response = await axios(`/api/v1/getAllJobsDetailsOfCustomer?id=${id}`, {
			method: "GET",
			headers: {
				"Content-Type": "application/json",
				token,
				methods: "GET",
			},
			credentials: "include",
		});
		if (response) {
			dispatch({
				type: JOBS_DETAILS_SUCCESS,
				payload: response.data.getAllJobs,
			});
		} else {
			dispatch({
				type: JOBS_DETAILS_FAIL,
				payload: "Failed to get job details",
			});
		}
	} catch (error) {
		dispatch({
			type: JOBS_DETAILS_FAIL,
			payload: error?.response?.data?.message,
		});
	}
};

// Update User
export const updateUser = (id, userData) => async (dispatch) => {
	try {
		dispatch({ type: UPDATE_USER_REQUEST });
		const token = getCorporateToken();
		const config = { headers: { "Content-Type": "application/json" }, token };

		const { data } = await axios.put(
			`/api/v1/admin/user/${id}`,
			userData,
			config,
		);

		dispatch({ type: UPDATE_USER_SUCCESS, payload: data?.success });
	} catch (error) {
		dispatch({
			type: UPDATE_USER_FAIL,
			payload: error?.response?.data?.message,
		});
	}
};

// Delete User
export const deleteUser = (id) => async (dispatch) => {
	try {
		dispatch({ type: DELETE_USER_REQUEST });

		const { data } = await axios.delete(`/api/v1/admin/user/${id}`);

		dispatch({ type: DELETE_USER_SUCCESS, payload: data });
	} catch (error) {
		dispatch({
			type: DELETE_USER_FAIL,
			payload: error?.response?.data?.message,
		});
	}
};

// Clearing Errors
export const clearErrors = () => async (dispatch) => {
	dispatch({ type: CLEAR_ERRORS });
};

//toggle language

//export const TOGGLE_IS_ON = 'TOGGLE_IS_ON';

export const toggleIsOn = () => ({
	type: TOGGLE_IS_ON,
});

export const setLogo = () => (dispatch) => {
	const url = window.location.href;
	let logo = "/images/logo.png";

	dispatch({
		type: SET_LOGO,
		payload: logo,
	});
};

export const notifications = () => async (dispatch) => {
	try {
		dispatch({ type: NOTIFICATIONS_REQUEST });

		const { data } = await axios.get(`/api/v1/notifications`);

		dispatch({ type: NOTIFICATIONS_SUCCESS, payload: data });

		return { status: 200, data };
	} catch (error) {
		dispatch({
			type: NOTIFICATIONS_FAIL,
			payload: error?.response?.data?.message || "Failed to fetch notifications",
		});
	}
};

export const getTeamMembers = (orgAdminId) => async (dispatch) => {
	try {
		dispatch({ type: TEAM_MEMBERS_REQUEST });

		const data  = await axios.get(`/api/v1/teamMembers`, {
			 params: { orgAdminId: orgAdminId } 
		  });
		dispatch({ type: TEAM_MEMBERS_SUCCESS, payload: data.data.members });
		return { status: 200, data: data.data.members };
	} catch (error) {
		dispatch({
			type: TEAM_MEMBERS_FAIL,
			payload: error?.response?.data?.message || "Failed to fetch team members",
		});
	}
};